"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var PanelForm = /*#__PURE__*/function (_Vue) {
  function PanelForm() {
    var _this;
    (0, _classCallCheck2.default)(this, PanelForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, PanelForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "title", void 0);
    (0, _defineProperty2.default)(_this, "description", void 0);
    return _this;
  }
  (0, _inherits2.default)(PanelForm, _Vue);
  return (0, _createClass2.default)(PanelForm);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: "Default title"
})], PanelForm.prototype, "title", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: ""
})], PanelForm.prototype, "description", void 0);
PanelForm = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], PanelForm);
var _default = exports.default = PanelForm;